import { PmcPage } from '@/api/model/base'
import { ServerConfig } from '@/config/server-config'
import { from, Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { ReceiptAPIConstant } from '../constant/receipt'
import { BaseService } from './base-service'

export class ReceiptService extends BaseService {
    protected receiptConstant: ReceiptAPIConstant

    constructor() {
        super()
        this.receiptConstant = new ReceiptAPIConstant()
    }

    abroadPaymentList(data = {}): Observable<PmcPage<any>> {
        return this.requestPmc(this.receiptConstant.AbroadPaymentList(data))
    }

    abroadPaymentListAmount(data = {}): Observable<any> {
        return this.requestPmc(this.receiptConstant.AbroadPaymentListAmount(data))
    }

    outcomeDetailList(data = {}): Observable<PmcPage<any>> {
        return this.requestPmc(this.receiptConstant.OutcomeDetailList(data))
    }

    abroadDeductList(data = {}): Observable<PmcPage<any>> {
        return this.requestPmc(this.receiptConstant.AbroadDeductList(data))
    }

    abroadDeductListAmount(data = {}): Observable<any> {
        return this.requestPmc(this.receiptConstant.AbroadDeductListAmount(data))
    }

    createRepaymentCode(data = {}): Observable<any> {
        return this.requestPmc(this.receiptConstant.CreateRepaymentCode(data))
    }

    repaymentPayChannelList(data = {}): Observable<any> {
        return this.requestPmc(this.receiptConstant.RepaymentPayChannelList(data))
    }

    repaymentTotalAmountByOrderId(data = {}): Observable<any> {
        return this.requestPmc(this.receiptConstant.RepaymentTotalAmountByOrderId(data))
    }

    repaymentPayTypeList(data = {}): Observable<any> {
        return this.requestPmc(this.receiptConstant.RepaymentPayTypeList(data))
    }

    abroadDeductGetDetailList(data = {}): Observable<PmcPage<any>> {
        return this.requestPmc(this.receiptConstant.AbroadDeductGetDetailList(data))
    }

    payFail(data = {}): Observable<number> {
        return this.requestPmc(this.receiptConstant.PayFail(data))
    }

    payResend(data = {}): Observable<number> {
        return this.requestPmc(this.receiptConstant.PayResend(data))
    }

    confirmPay(data = {}): Observable<number> {
        return this.requestPmc(this.receiptConstant.ConfirmPay(data))
    }

    payReject(data = {}): Observable<number> {
        return this.requestPmc(this.receiptConstant.PayReject(data))
    }

    changeOprType(data = {}): Observable<number> {
        return this.requestPmc(this.receiptConstant.ChangeOprType(data))
    }

    exportAbroadPaymentList(data: any): Observable<void> {
        const { current, size, createDate, closeDate, closeTimeStart, closeTimeEnd, createTimeStart, createTimeEnd, ...requestData } = data
        requestData.pageNum = current
        requestData.pageSize = size
        if (closeTimeStart) {
            requestData.closeTimeStart = new Date(closeTimeStart)
        }
        if (closeTimeEnd) {
            requestData.closeTimeEnd = new Date(closeTimeEnd)
        }
        if (createTimeStart) {
            requestData.createTimeStart = new Date(createTimeStart)
        }
        if (createTimeEnd) {
            requestData.createTimeEnd = new Date(createTimeEnd)
        }
        const handler = () => {
            const httpOption = this.receiptConstant.ExportAbroadPaymentList(requestData)
            location.href = `${ServerConfig.PaymentUrl}${httpOption.url}?${this.parseParam(requestData)}`
        }
        return from([0]).pipe(map(handler))
    }

    exportAbroadRePaymentList(data: any): Observable<void> {
        const { current, size, ...requestData } = data
        requestData.pageNum = current
        requestData.pageSize = size
        const handler = () => {
            const httpOption = this.receiptConstant.ExportAbroadRePaymentList(requestData)
            location.href = `${ServerConfig.PaymentUrl}${httpOption.url}?${this.parseParam(requestData)}`
        }
        return from([0]).pipe(map(handler))
    }

    parseParam(data = {}) {
        return Object.keys(data)
            .filter(function(key) {
                return (data[key] && !Array.isArray(data[key])) || (Array.isArray(data[key]) && data[key].length > 0)
            })
            .map(function(key) {
                return encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
            })
            .join('&')
    }

    getBankSlipsList(data = {}) {
        return this.requestPmc(this.receiptConstant.BankSlipsList(data))
    }

    getOperators(data = {}) {
        return this.requestPmc(this.receiptConstant.Operators(data))
    }

    uploadBankSlipsFile(data = {}) {
        return this.requestPmc(this.receiptConstant.BankSlipsFile(data))
    }

    getBindingList(data = {}) {
        return this.requestPmc(this.receiptConstant.BindingList(data))
    }

    bindingSubmit(data = {}) {
        return this.requestPmc(this.receiptConstant.BindingSubmit(data))
    }

    getAllAmount(data = {}) {
        return this.requestPmc(this.receiptConstant.AllAmount(data))
    }

    download() {
        return this.requestPmc(this.receiptConstant.Download())
    }
}
